import { render, staticRenderFns } from "./CompletaQuestionario.vue?vue&type=template&id=5149e00c&"
import script from "./CompletaQuestionario.vue?vue&type=script&lang=js&"
export * from "./CompletaQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports